<script setup lang="ts">
const store = usePortfolioStore()
const barColors = ['from-[#c9b3f6] to-[#b193ef]', 'from-[#f9bcd0] to-[#f49ab8]', 'from-[#fbe3a9] to-[#f6d178]', 'from-[#bcdcb9] to-[#9cc898]', 'from-[#b3cdf5] to-[#8fb0ef]']
const skills = computed(() => {
  const profileSkills = store.profile?.skills
  if (!Array.isArray(profileSkills)) return store.skills

  return profileSkills.map(skill => ({
    name: skill.title ?? skill.name ?? '',
    level: Number(skill.percent ?? skill.level ?? 0)
  }))
})
</script>

<template>
  <section id="skills" data-reveal
           class="flex flex-col rounded-[26px] p-5 shadow-[var(--t-clay)] [background:var(--t-sect4)]">
    <div class="flex items-center justify-between gap-2.5">
      <h2 class="text-base font-extrabold text-[var(--t-h14)]">مهارت‌های من</h2>
      <span class="rounded-full bg-white/80 px-3 py-1 text-[11px] font-bold text-[var(--t-badge4)]
                   shadow-[inset_0_2px_3px_rgb(255_255_255/0.9),0_3px_8px_rgb(190_70_120/0.12)]">سطح تسلط</span>
    </div>
    <div class="mt-4.5 grid min-h-[205px] flex-1 grid-cols-[auto_1fr] gap-2.5">
      <div class="flex flex-col justify-between pb-6 text-left text-[9.5px] font-bold text-[var(--t-axis4)]">
        <span>۱۰۰</span><span>۷۵</span><span>۵۰</span><span>۲۵</span><span>۰</span>
      </div>
      <div class="overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div class="flex h-full items-stretch justify-around gap-2"
             :style="{ minWidth: Math.max(skills.length * 52, 200) + 'px' }">
          <div v-for="(skill, i) in skills" :key="skill.name" class="flex min-w-[44px] flex-1 flex-col items-center gap-1.5">
            <div class="flex w-full flex-1 items-end justify-center">
              <div :title="skill.level + '٪'"
                   class="w-[min(30px,76%)] rounded-full bg-gradient-to-b
                          shadow-[inset_0_3px_4px_rgb(255_255_255/0.75),inset_0_-5px_8px_rgb(120_60_120/0.18),0_8px_16px_rgb(150_70_110/0.28),0_3px_6px_rgb(150_70_110/0.18)]"
                   :class="barColors[i % 5]" :style="{ height: skill.level + '%' }"></div>
            </div>
            <span class="h-[18px] max-w-full truncate text-[10.5px] font-bold text-[var(--t-badge4)]">{{ skill.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
